import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { formatarDataHoraLocal } from '../../utils/formatar-data-hora-local';
import { NbActionsModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDatepickerModule, NbDialogModule, NbDialogService, NbIconModule, NbInputModule, NbLayoutModule, NbOptionModule, NbOverlayModule, NbRadioModule, NbSelectModule, NbSidebarModule, NbSpinnerModule, NbToastrService, NbUserModule } from '@nebular/theme';
import { InscricaoCatequese } from '../../core/api/inscricao';
import { FormsModule } from '@angular/forms';
import { InscricaoService } from '../../core/api/inscricao.service';
import { PreInscricaoService } from '../../core/api/pre-inscricao.service';
import { NgIf } from '@angular/common';
import { calcularIdade } from '../../utils/calcular-idade';
import { validarCPF } from '../../utils/validar-cpf';
import { CepService } from '../../core/api/cep.service';
import { NgxMaskDirective } from 'ngx-mask';
import { ActivatedRoute } from '@angular/router';
import { DialogAlertComponent } from './inscricao.dialog.component';

import { mensagemDeErro } from '../../utils/mensagem-erro';
import { HttpErrorResponse } from '@angular/common/http';
import { MASCARAS } from '../../utils/mascaras';
import { CampoDataComponent } from '../../shared/campo-data/campo-data.component';
@Component({
  selector: 'app-inscricao',
  standalone: true,
  imports: [
    FormsModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    NbActionsModule,
    NbUserModule,
    NbCheckboxModule,
    NbRadioModule,
    NbDatepickerModule,
    NbSelectModule,
    NbOptionModule,
    NbSidebarModule,
    NbIconModule,
    NbSpinnerModule,
    NgIf,
    NgxMaskDirective,
    CampoDataComponent,
    ],
  templateUrl: './inscricao.component.html',
  styleUrl: './inscricao.component.scss'
})
export class InscricaoComponent implements OnInit {
  /** `FRM-10` — máscara vem de um lugar só. */
  protected readonly mascaras = MASCARAS;


 
  inscricao: InscricaoCatequese = new InscricaoCatequese();

  finalizado: boolean = false;

  /**
   * Pré-inscrição: o horário em que a API pôs a família (`agendaDataHora` do `201`), já no
   * formato da tela. É o que ela precisa guardar. Vazio na inscrição em turma, ou se não veio.
   */
  atendimento = '';

  carregandoCpfCatequizando = false;

  salvando = false;
  erroSalvamento: string | null = null;
  mensagemProgresso = '';

  private route = inject(ActivatedRoute);
  turmaId!: string;

  /**
   * Preenchido, a ficha é de **pré-inscrição**: vai para
   * `POST /pre-inscricoes/{campanhaId}/inscritos`, sem `turmaId`, e o grupo é inferido da
   * data de nascimento pela API. Vazio, é a inscrição em turma de sempre.
   *
   * O formulário é o mesmo nos dois casos — por isso ele não foi copiado.
   */
  @Input() campanhaId?: string;

  /** Data de nascimento já conferida na porta da pré-inscrição (`yyyy-MM-dd`). */
  @Input() dataNascimentoFixa?: string;

  /**
   * A API recusou o envio com `400`. São dois casos, e os dois são regra de negócio, não falha:
   * a última vaga foi ocupada entre a consulta e o envio, ou este CPF já tem pré-inscrição
   * nesta campanha. A mensagem do backend distingue os dois — quem a exibe é a tela de fora.
   */
  @Output() envioRecusado = new EventEmitter<string>();

  /**
   * Data de nascimento que veio da consulta do CPF. Na pré-inscrição ela pode **mudar o
   * grupo**: quem decide a faixa é a idade, e a data do documento vale mais do que a que foi
   * digitada na porta.
   */
  @Output() dataNascimentoDoCpf = new EventEmitter<string>();

  /**
   * Motivo pelo qual esta ficha não pode ser enviada agora — na pré-inscrição, a faixa etária
   * da data atual está cheia ou não existe. Preenchido, a ficha continua visível (ninguém
   * perde o que digitou) e o envio é recusado com este texto.
   */
  @Input() bloqueio: string | null = null;

  /** Campos preenchidos pela consulta do CPF ficam em leitura: o documento é a fonte. */
  nomeTravadoPorCpf = false;
  dataNascimentoTravadaPorCpf = false;
  nomeMaeTravadoPorCpf = false;
  nomePaiTravadoPorCpf = false;

  /** CPF já consultado, em dígitos — evita repetir a chamada a cada `blur` no mesmo número. */
  private cpfConsultado = '';
  private cpfMaeConsultado = '';
  private cpfPaiConsultado = '';

  carregando = {
    mae: false,
    pai: false,
    catequizando: false
  };

  constructor(
    private inscricaoService: InscricaoService,
    private preInscricaoService: PreInscricaoService,
    private toastrService: NbToastrService,
    private cepService: CepService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    if (this.campanhaId) {
      // Pré-inscrição não tem turma: o grupo sai da idade, apurada pela API.
      this.inscricao.dataNascimento = this.dataNascimentoFixa ?? '';
      return;
    }

    this.route.paramMap.subscribe(params => {
      this.turmaId = params.get('turmaId') ?? '';
      this.inscricao.turmaId = this.turmaId;
    });
  }

  get ehPreInscricao(): boolean {
    return !!this.campanhaId;
  }

  /**
   * `FRM-07` — serviço indisponível ou documento não encontrado **não bloqueia** o cadastro:
   * avisa e libera o preenchimento manual. `MSG-07` — nada disso é culpa de quem está na
   * tela, então é aviso, não erro. `MSG-02` — o texto é o que o backend escreveu.
   *
   * `404` e `502` são coisas diferentes e a pessoa age diferente em cada uma: sem cadastro,
   * ela digita e segue; sem conseguir consultar, ela digita e segue **também**, mas sabe que
   * não foi o CPF dela que estava errado.
   */
  private avisarFalhaConsultaCpf(err: unknown, quem: string): void {
    const status = err instanceof HttpErrorResponse ? err.status : 0;

    if (status === 404) {
      this.toastrService.info(
        mensagemDeErro(err, `Nenhum cadastro encontrado para este CPF. Preencha os dados de ${quem} à mão.`),
        'CPF sem cadastro',
      );
      return;
    }

    this.toastrService.warning(
      mensagemDeErro(err, `Não foi possível consultar o CPF agora. Preencha os dados de ${quem} à mão.`),
      'Consulta indisponível',
    );
  }

  buscarDadosCatequizando() {
    const cpf = this.inscricao.cpfCatequizando;
    const digitos = (cpf ?? '').replace(/\D/g, '');

    if (digitos.length !== 11) {
      return;
    }

    // `FRM-07` — valida o documento **antes** de sair para a rede. Este caminho conferia só
    // o tamanho, então CPF de dígito repetido (00000000000 e afins) ia para a API e voltava
    // como 400. A conta dos dígitos verificadores fecha para eles; não são CPF mesmo assim, e
    // validarCPF já os rejeita — faltava chamá-la aqui, como os outros três pontos fazem.
    if (!validarCPF(digitos)) {
      this.toastrService.warning(
        'Confira o CPF do catequizando: os dígitos não formam um documento válido.',
        'CPF inválido',
      );
      return;
    }

    this.carregandoCpfCatequizando = true;
    this.inscricaoService.buscarPorCpf(digitos).subscribe({
      next: (dados) => {
        this.inscricao.nomeCatequizando = dados.nome || '';
        this.inscricao.dataNascimento = dados.dataNascimento || '';
        this.carregandoCpfCatequizando = false;
      },
      error: (err) => {
        this.avisarFalhaConsultaCpf(err, 'o catequizando');
        this.carregandoCpfCatequizando = false;
      }
    });
  }

  onSemCpfChangePais(checked: boolean) {
    if (checked) {
      this.dialogService.open(DialogAlertComponent, {
        context: {
          title: 'Atenção',
          message: 'Ao marcar esta opção será registrado sem CPF. Faça isso somente se não souber este CPF. Tenha certeza de digitar o nome corretamente, no campo abaixo. Estes dados são necessários para a emissão da documentação final. Esteja ciente da sua responsabilidade em fornecer os dados de forma correta.',
        },
      });
    }
  }

  /**
   * "Não" desfaz o que só existe para quem é batizado — igreja do batismo e os sacramentos que
   * dependem dele —, para não sair na ficha uma resposta que a tela já escondeu.
   */
  aoMudarBatizado(batizado: boolean): void {
    if (batizado) return;
    this.inscricao.igrejaBatismo = undefined;
    this.inscricao.nomeIgrejaBatismo = undefined;
    this.inscricao.primeiraComunhao = false;
    this.inscricao.matrimonio = false;
    this.inscricao.situacaoMatrimonio = undefined;
  }

  aoMudarIgrejaBatismo(igreja: 'catolica' | 'nao_catolica'): void {
    if (igreja !== 'nao_catolica') this.inscricao.nomeIgrejaBatismo = undefined;
  }

  buscarEnderecoPorCep(): void {
    const cep = this.inscricao.cep;
    if (!cep || cep.replace(/\D/g, '').length !== 8) return;

    this.inscricao.cep = '';

    this.cepService.buscar(cep).subscribe({
      next: (dados) => {
        if(dados.erro){
          this.toastrService.danger(`O CEP ${cep} não foi encontrado`, 'Cep não encontrado');
        }else{
          this.inscricao.cep = cep;
          this.inscricao.endereco = dados.logradouro;
          this.inscricao.bairro = dados.bairro;
          this.inscricao.complemento = dados.complemento;
          this.inscricao.municipio = dados.localidade + ' - ' + dados.uf;
          this.inscricao.municipioIbge = dados.ibge;
        }
      },
      error: (err) => {
        console.error('Erro ao buscar CEP:', err);
      }
    });
  }  

  /**
   * Consulta assim que o CPF fica completo, sem esperar o campo perder o foco: quem digita os
   * onze dígitos e vai direto para o próximo campo não via nome nem data chegarem.
   */
  /**
   * Toda mudança da data de nascimento reclassifica, não só a que vem do CPF: quem corrige a
   * data na mão muda de faixa etária do mesmo jeito. Quem decide se há vaga é a tela de fora,
   * que fala com a API.
   */
  aoMudarDataNascimento(data: string | undefined): void {
    if (!this.campanhaId) return;
    const valor = (data ?? '').trim();
    if (valor.length !== 10) return;
    this.dataNascimentoDoCpf.emit(valor);
  }

  /** O campo de data devolve ISO ou vazio; vazio é data incompleta ou impossível. */
  aoInformarDataNascimento(iso: string): void {
    this.inscricao.dataNascimento = iso;
    this.aoMudarDataNascimento(iso);
  }

  /**
   * Mesma regra do catequizando para os responsáveis: consulta quando o CPF fica completo, e o
   * nome que vier do documento não se digita por cima. Corrigir o CPF destrava o nome.
   */
  aoDigitarCpfResponsavel(valor: string | undefined, destino: 'mae' | 'pai'): void {
    const digitos = (valor ?? '').replace(/\D/g, '');
    const anterior = destino === 'mae' ? this.cpfMaeConsultado : this.cpfPaiConsultado;

    if (digitos.length < 11) {
      if (destino === 'mae') {
        this.cpfMaeConsultado = '';
        this.nomeMaeTravadoPorCpf = false;
        this.inscricao.cpfMaeConsultado = false;
      } else {
        this.cpfPaiConsultado = '';
        this.nomePaiTravadoPorCpf = false;
        this.inscricao.cpfPaiConsultado = false;
      }
      return;
    }

    if (digitos === anterior) return;
    if (destino === 'mae') {
      this.cpfMaeConsultado = digitos;
    } else {
      this.cpfPaiConsultado = digitos;
    }
    this.buscarDadosPorCpf(digitos, destino);
  }

  aoDigitarCpfCatequizando(valor: string | undefined): void {
    const digitos = (valor ?? '').replace(/\D/g, '');

    if (digitos.length < 11) {
      // Apagou ou está corrigindo: o que veio do documento deixa de valer e os campos voltam
      // a aceitar digitação.
      this.cpfConsultado = '';
      this.nomeTravadoPorCpf = false;
      this.dataNascimentoTravadaPorCpf = false;
      this.inscricao.cpfCatequizandoConsultado = false;
      return;
    }

    if (digitos === this.cpfConsultado) return;
    this.cpfConsultado = digitos;
    this.buscarDadosPorCpf(digitos, 'catequizando');
  }

  buscarDadosPorCpf(cpf: string | undefined, destino: 'mae' | 'pai' | 'catequizando') {
    const cpfLimpo = (cpf || '').replace(/\D/g, '');
    if (!cpfLimpo || cpfLimpo.length !== 11) return;

    if(validarCPF(cpfLimpo)){
      // ativa indicador visual
      this.carregando[destino] = true;
    
      this.inscricaoService.buscarPorCpf(cpfLimpo).subscribe({
        next: (dados) => {
          if (destino === 'mae') {
            this.inscricao.nomeMae = dados.nome || '';
            this.nomeMaeTravadoPorCpf = !!dados.nome;
            this.inscricao.cpfMaeConsultado = true;
          } else if (destino === 'pai') {
            this.inscricao.nomePai = dados.nome || '';
            this.nomePaiTravadoPorCpf = !!dados.nome;
            this.inscricao.cpfPaiConsultado = true;
          } else if (destino === 'catequizando') {
            this.inscricao.nomeCatequizando = dados.nome || '';
            this.nomeTravadoPorCpf = !!dados.nome;

            if (dados.dataNascimento) {
              this.inscricao.dataNascimento = dados.dataNascimento;
              this.dataNascimentoTravadaPorCpf = true;
              this.aoMudarDataNascimento(dados.dataNascimento);
            }

            this.inscricao.cpfCatequizandoConsultado = true;
          }
          this.carregando[destino] = false;
        },
        error: (err) => {
          const quem =
            destino === 'mae' ? 'a mãe' : destino === 'pai' ? 'o pai' : 'o catequizando';
          this.avisarFalhaConsultaCpf(err, quem);
          this.carregando[destino] = false;
        }
      });
    }else{
      this.toastrService.danger(`CPF ${cpfLimpo} é inválido.`, 'Erro');
    }
  }

  isAdulto(){
    const idade = calcularIdade(this.inscricao.dataNascimento ?? null);
    return idade !== null && idade >= 18;
  }

  isCrianca(){
    const idade = calcularIdade(this.inscricao.dataNascimento ?? null);
    return idade !== null && idade < 18;
  }

  getIdade(){
    const idade = calcularIdade(this.inscricao.dataNascimento ?? null);
    return idade;
  }

  isTemCatequizando(){
    return this.inscricao.cpfCatequizando && this.inscricao.nomeCatequizando && this.inscricao.dataNascimento;
  }

  private readonly mensagensProgresso = [
    'Salvando seus dados...',
    'Integrando com sistemas da Paróquia',
    'Integrando com arquidiocese...',
  ];

  private intervaloMensagens: ReturnType<typeof setInterval> | null = null;

  private iniciarAnimacaoMensagens(): void {
    let indice = 0;
    this.mensagemProgresso = this.mensagensProgresso[0];
    this.intervaloMensagens = setInterval(() => {
      indice = (indice + 1) % this.mensagensProgresso.length;
      this.mensagemProgresso = this.mensagensProgresso[indice];
    }, 2500);
  }

  private pararAnimacaoMensagens(): void {
    if (this.intervaloMensagens) {
      clearInterval(this.intervaloMensagens);
      this.intervaloMensagens = null;
    }
  }

  private iniciarSalvamento(): void {
    this.salvando = true;
    this.erroSalvamento = null;
    this.iniciarAnimacaoMensagens();

    // Inscrição em turma não devolve corpo; pré-inscrição devolve o inscrito, com o atendimento.
    const envio: Observable<unknown> = this.campanhaId
      ? this.preInscricaoService.enviarInscrito(this.campanhaId, this.inscricao)
      : this.inscricaoService.enviarInscricao(this.inscricao);

    envio.subscribe({
      next: (resposta) => {
        const agenda = (resposta as { agendaDataHora?: string | null } | null)?.agendaDataHora;
        this.atendimento = agenda ? formatarDataHoraLocal(agenda) : '';
        this.pararAnimacaoMensagens();
        this.salvando = false;
        this.inscricao = new InscricaoCatequese();
        this.inscricao.turmaId = this.turmaId;
        this.finalizado = true;
        this.toastrService.success('Cadastro finalizado com sucesso');
      },
      error: (err) => {
        this.pararAnimacaoMensagens();
        this.salvando = false;
        const mensagem = mensagemDeErro(err, 'Erro ao salvar inscrição. Tente novamente.');

        // 400 na pré-inscrição é regra de negócio: vaga ocupada no meio do caminho, ou CPF já
        // pré-inscrito nesta campanha. Quem sabe qual é a mensagem do backend.
        if (this.campanhaId && err instanceof HttpErrorResponse && err.status === 400) {
          this.envioRecusado.emit(mensagem);
          return;
        }

        this.erroSalvamento = mensagem;
      }
    });
  }

  fecharErro(): void {
    this.erroSalvamento = null;
  }

  salvar(){
    if (this.bloqueio) {
      this.toastrService.warning(this.bloqueio, 'Sem vaga para esta data de nascimento');
      return;
    }

    const valido = this.ehPreInscricao ? this.validarPreInscricao() : this.validar();
    if (valido) {

      this.dialogService.open(DialogAlertComponent, {
        context: {
          title: 'Atenção',
          message: '',
          mostrarConfirmacao: true,
          msgConfirmacao: 'Declaro que as informações fornecidas são verdadeiras e estou ciente de que serão utilizadas exclusivamente para a elaboração da documentação final. Autorizo o armazenamento e o tratamento destes dados pela Arquidiocese de Goiânia, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).'
        }
      }).onClose.subscribe((resultado: boolean) => {
        if (resultado) {
          this.iniciarSalvamento();
        }
      });
    }
  }

  /**
   * Regras da **pré-inscrição**, que são outras: lá o CPF do catequizando é a chave (traz nome e
   * data, e a data define o grupo), e o responsável só é exigido de quem é menor de idade. A
   * inscrição em turma continua com `validar()`, que pede mãe e pai em qualquer idade.
   */
  private validarPreInscricao(): boolean {
    let valido = true;
    const erro = (texto: string) => {
      this.toastrService.danger(texto, 'Faltam dados');
      valido = false;
    };

    const cpfCatequizando = this.soDigitos(this.inscricao.cpfCatequizando);
    const cpfMae = this.soDigitos(this.inscricao.cpfMae);
    const cpfPai = this.soDigitos(this.inscricao.cpfPai);

    if (!this.inscricao.nomeCatequizando?.trim()) erro('Nome do catequizando é obrigatório.');
    if (!this.inscricao.dataNascimento?.trim()) erro('Data de nascimento é obrigatória.');

    if (!cpfCatequizando || !validarCPF(cpfCatequizando)) {
      erro('CPF do catequizando é obrigatório e precisa ser válido.');
    }

    // Documento é de uma pessoa só: CPF repetido entre catequizando, mãe e pai é sempre erro
    // de digitação, e passaria batido porque cada campo, sozinho, é um CPF válido.
    if (cpfMae && cpfMae === cpfCatequizando) erro('O CPF da mãe não pode ser o mesmo do catequizando.');
    if (cpfPai && cpfPai === cpfCatequizando) erro('O CPF do pai não pode ser o mesmo do catequizando.');
    if (cpfMae && cpfPai && cpfMae === cpfPai) erro('O CPF do pai não pode ser o mesmo da mãe.');

    if (cpfMae && !validarCPF(cpfMae)) erro('O CPF da mãe não é válido.');
    if (cpfPai && !validarCPF(cpfPai)) erro('O CPF do pai não é válido.');

    // Sem data de nascimento não há idade, e sem idade não dá para exigir responsável: o erro
    // que importa nesse caso é o da data, já apontado acima.
    const idade = this.getIdade();
    const menor = idade != null && idade < 18;
    if (menor && !cpfMae && !cpfPai) {
      erro(`Catequizando com ${idade} anos: informe o CPF do pai ou da mãe.`);
    }

    // Nomes de mãe e pai são exigidos em qualquer idade; o do pai só dispensa quem marcou que ele
    // não está declarado em documento.
    if (!this.inscricao.nomeMae?.trim()) erro('Informe o nome da mãe.');
    if (!this.inscricao.naoConstaPai && !this.inscricao.nomePai?.trim()) erro('Informe o nome do pai.');

    // O e-mail é por onde chega a confirmação do atendimento: o do próprio catequizando, se
    // adulto; o de um dos responsáveis, se menor.
    if (idade != null && !menor && !this.inscricao.emailCatequizando?.trim()) {
      erro('Informe o e-mail do catequizando.');
    }
    if (menor && !this.inscricao.emailMae?.trim() && !this.inscricao.emailPai?.trim()) {
      erro(`Catequizando com ${idade} anos: informe o e-mail da mãe ou do pai.`);
    }

    if (this.inscricao.batizado == null) {
      erro('Informe se o catequizando é batizado.');
    } else if (this.inscricao.batizado) {
      if (!this.inscricao.igrejaBatismo) {
        erro('Informe se o batismo foi em Igreja Católica Apostólica Romana ou em Igreja não Católica.');
      } else if (this.inscricao.igrejaBatismo === 'nao_catolica' && !this.inscricao.nomeIgrejaBatismo?.trim()) {
        erro('Informe em qual Igreja foi o batismo.');
      }
    }

    if (
      !this.inscricao.cep?.trim() ||
      !this.inscricao.endereco?.trim() ||
      !this.inscricao.bairro?.trim() ||
      !this.inscricao.municipio?.trim()
    ) {
      erro('Endereço é obrigatório: preencha CEP, logradouro, bairro e município.');
    }

    const temTelefone =
      !!this.inscricao.celularCatequizando?.trim() ||
      !!this.inscricao.telefoneMae?.trim() ||
      !!this.inscricao.telefonePai?.trim();
    if (!temTelefone) {
      erro('Telefone é obrigatório: informe o do catequizando ou o de um responsável.');
    }

    return valido;
  }

  private soDigitos(valor: string | undefined | null): string {
    return (valor ?? '').replace(/\D/g, '');
  }

  validar(){
    let valido: boolean = true;
    if (!this.inscricao.nomeCatequizando?.trim()) {
      this.toastrService.danger(`Nome obrigatório`, 'Faltam dados');
      valido = false;
    }
    if (!this.inscricao.dataNascimento?.trim()) {
      this.toastrService.danger(`Data de nascimento do catequizando obrigatória`, 'Faltam dados');
      valido = false;
    }
    if (!this.inscricao.sexo?.trim()) {
      this.toastrService.danger(`Sexo catequizando obrigatório`, 'Faltam dados');
      valido = false;
    }
    if (!this.inscricao.cep?.trim() || !this.inscricao.endereco?.trim() || !this.inscricao.bairro?.trim() || !this.inscricao.complemento?.trim() || !this.inscricao.municipio?.trim() ) {
      this.toastrService.danger(`Endereço do catequizando obrigatório. Preencha de forma completa, cep, bairro, complemento, etc`, 'Faltam dados');
      valido = false;
    }

    if (!this.inscricao.nomeMae?.trim()) {
      this.toastrService.danger(`Nome da mãe do catequizando é obrigatório`, 'Faltam dados');
      valido = false;
    }

    if (!this.inscricao.naoConstaPai && !this.inscricao.nomePai?.trim()) {
      this.toastrService.danger(`Nome da pai do catequizando é obrigatório`, 'Faltam dados');
      valido = false;
    }

    if(this.isCrianca()){
      if (!this.inscricao.cpfCatequizando?.trim() || !validarCPF(this.inscricao.cpfCatequizando)) {
        this.toastrService.danger(`Cpf do catequizando não informado ou inválido`, 'Faltam dados');
        valido = false;
      }
      if(!this.inscricao.cpfMae?.trim() && !this.inscricao.cpfPai?.trim()){
        this.toastrService.danger(`Catequizando com ${this.getIdade()} anos. Informe o cpf de um responsável, pai ou mãe`, 'Faltam dados');
        valido = false;
      }
      if(!this.inscricao.telefoneMae?.trim() && !this.inscricao.telefonePai?.trim()){
        this.toastrService.danger(`Catequizando com ${this.getIdade()} anos. Informe o telefone de um responsável, pai ou mãe`, 'Faltam dados');
        valido = false;
      }
      if(!this.inscricao.emailMae?.trim() && !this.inscricao.emailPai?.trim()){
        this.toastrService.danger(`Catequizando com ${this.getIdade()} anos. Informe o email de um responsável, pai ou mãe`, 'Faltam dados');
        valido = false;
      }

      if (!this.inscricao.cpfMae?.trim()) {
        this.toastrService.danger(`CPF da mãe do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
      if (!this.inscricao.naoConstaPai && !this.inscricao.cpfPai?.trim()) {
        this.toastrService.danger(`CPF da pai do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
      if (!this.inscricao.nomeMae?.trim()) {
        this.toastrService.danger(`Nome da mãe do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
      if (!this.inscricao.naoConstaPai && !this.inscricao.nomePai?.trim()) {
        this.toastrService.danger(`Nome da pai do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
  
    }

    if(this.isAdulto()){
      if (!this.inscricao.cpfCatequizando?.trim() || !validarCPF(this.inscricao.cpfCatequizando)) {
        this.toastrService.danger(`Cpf do catequizando não informado ou inválido`, 'Faltam dados');
        valido = false;
      }
      if(!this.inscricao.emailCatequizando?.trim()){
        this.toastrService.danger(`Informe o email do catequizando`, 'Faltam dados');
        valido = false;
      }
      if(!this.inscricao.celularCatequizando?.trim()){
        this.toastrService.danger(`Informe o celular do catequizando`, 'Faltam dados');
        valido = false;
      }

      if (!this.inscricao.maeSemCpf && !this.inscricao.cpfMae?.trim()) {
        this.toastrService.danger(`CPF da mãe do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
      if (!this.inscricao.paiSemCpf && !this.inscricao.naoConstaPai && !this.inscricao.cpfPai?.trim()) {
        this.toastrService.danger(`CPF da pai do catequizando é obrigatório`, 'Faltam dados');
        valido = false;
      }
  
    }
    
    return valido;

  }

}